import { useEffect, useState } from "react";

const KEY = "bb_show_image";

export default function useShowImage(defaultValue = false) {
  const [show, setShow] = useState(() => {
    try {
      const v = localStorage.getItem(KEY);
      return v === null ? defaultValue : v === "true";
    } catch (err) { console.warn("[useShowImage] read failed:", err); return defaultValue; }
  });
  useEffect(() => {
    try { localStorage.setItem(KEY, String(show)); } catch (err) { console.warn("[useShowImage] write failed:", err); }
  }, [show]);
  return [show, setShow];
}
